module.exports = __webpack_public_path__ + "img/syndic_illu@2x.3c617036.png";